import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';

export default (state, orderId) => {

    let currentValidation = state.getIn(['workOrderDetails', orderId, 'orderClose', 'details', 'stepValidation']) || initialStepValidation;
    const serviceTypeId = state.getIn([
        'workOrderDetails',
        orderId,
        'schedulingSystemDetails',
        'details',
        'serviceOrderInfoV2',
        'serviceTypeId'
    ]);

    const closeCodes = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'closeCode'
    ]);

    const orderStatus = state.getIn([
        'workOrderDetails',
        orderId,
        'orderClose',
        'details',
        'closeOrderRequest',
        'orderStatus'
    ]);

    const availableCloseCodes = state.getIn(['workOrderDetails', orderId, 'closeCodes', 'details']);

    if (orderStatus === 'NoAccess') {
        return currentValidation.setIn([
            'closeCodes', 'isValid'
        ], true).setIn([
            'closeCodes', 'message'
        ], null);
    }

    if (orderStatus === 'Cancel') {
        return currentValidation.setIn([
            'closeCodes', 'isValid'
        ], true).setIn([
            'closeCodes', 'message'
        ], null);
    }

    if (serviceTypeId && (serviceTypeId.toLowerCase().includes('tc') || serviceTypeId.toLowerCase().includes('sr'))) {
        if (availableCloseCodes && closeCodes) {
            let secondaryCodeNotSelected = false;
            if (closeCodes.count() === 1) {
                const primaryCode = closeCodes.first();

                secondaryCodeNotSelected = availableCloseCodes.some(code => {
                    const secondaryCodesNumber = code.get('secondaryCodes') ? code.get('secondaryCodes').count() : 0;
                    return code.get('code') === primaryCode.get('code') && secondaryCodesNumber > 0
                });
            }

            if (secondaryCodeNotSelected) {
                return currentValidation.setIn([
                    'closeCodes', 'isValid'
                ], false).setIn([
                    'closeCodes', 'message'
                ], 'A secondary close code is required.');
            } else {
                currentValidation = currentValidation.setIn([
                    'closeCodes', 'isValid'
                ], true).setIn([
                    'closeCodes', 'message'
                ], '');
            }
        }
        else {
            currentValidation = currentValidation.setIn([
                'closeCodes', 'isValid'
            ], false).setIn([
                'closeCodes', 'message'
            ], 'No close codes found. Please refresh the close code list.');
        }
    }

    if (serviceTypeId) {
        if ((serviceTypeId.toLowerCase().includes('tc') || serviceTypeId.toLowerCase().includes('sr')) && (!closeCodes || closeCodes.count() <= 0)) {
            currentValidation = currentValidation.setIn([
                'closeCodes', 'isValid'
            ], false).setIn([
                'closeCodes', 'message'
            ], 'A close code is required.');
        }
        else {
            currentValidation = currentValidation.setIn([
                'closeCodes', 'isValid'
            ], true).setIn([
                'closeCodes', 'message'
            ], '');
        }
    }

    return currentValidation;

};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/closeCodeValidator.js